import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const OfferInformationWrapper = styled.div`
  .info-wrapper {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
  }
  .filter {
    font-size: 14px;
    text-align: center;
    color: #0D205F;
  }

  .ant-tag {
    margin: 0px;
  }
`
